import { AppointmentTypeWithColor } from 'src/models/appointment';

import { Callback } from 'src/util/query/models/Callback';

import { SetAppointmentTypesWithColorPayload } from '../interfaces';

export class GetAppointmentTypesWithColorCallBack extends Callback<Array<AppointmentTypeWithColor>> {
	public constructor(
		private readonly setAppointmentTypesWithColor: (payload: SetAppointmentTypesWithColorPayload) => void
	) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
	};

	successCallbackFunction = (successResponse: Array<AppointmentTypeWithColor>): void => {
		this.setAppointmentTypesWithColor({
			appointmentTypeWithColors: successResponse,
		});
	};
}
